import { IconProps } from '../../Interfaces/Props';

const IconAttendance = (props: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.size ?? '24'}
      height={props.size ?? '24'}
      className={props.className}
      viewBox="0 0 2048 2048"
    >
      <rect width="2048" height="2048" fill="none" />
      <path
        fill="currentColor"
        d="M1792 0v1792H256V0zm-128 128H384v1536h1280zM640 896H512V768h128zm896 0H768V768h768zm-896 384H512v-128h128zm896 0H768v-128h768zM640 512H512V384h128zm896 0H768V384h768z"
      />
    </svg>
  );
};

export default IconAttendance;
